type WorkspaceTelemetryPayload = Record<string, unknown>;

export const trackWorkspaceEvent = (event: string, payload: WorkspaceTelemetryPayload = {}) => {
  const detail = {
    event,
    payload,
    timestamp: new Date().toISOString(),
  };

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("artwork-workspace-telemetry", { detail }));
  }

  if (process.env.NODE_ENV !== "production") {
    // Keep this feature-scoped and lightweight.
    // eslint-disable-next-line no-console
    console.debug("[artwork-workspace]", detail);
  }
};
